import BusinessIcon from "@material-ui/icons/Business";
import ComercialActivitiesList from "./ComercialActivityList";

export default {
  list: ComercialActivitiesList,
  icon: BusinessIcon,
};
